module.exports = __webpack_public_path__ + "static/media/success_validation.434dd248.svg";